import { HttpErrorResponse } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { BaseApiService, CoreInjectorTokens, Environment, GetManyV2Dto, ResponseDto } from '@fleet-beat/core';
import { catchError, map, Observable, of } from 'rxjs';
import { AssistantReportDto } from '../../models';

@Injectable({
  providedIn: 'root',
})
export class AssistantReportsApiService {
  private readonly baseUrl: string = `${this.environment.apiEndpoint}/external/assistant-reports`;

  constructor(
    @Inject(CoreInjectorTokens.Environment) private environment: Environment,
    private baseApiService: BaseApiService,
  ) {}

  // NOTE uses Api-Key authorization instead of the user Bearer token
  getMany(params: GetManyV2Dto): Observable<AssistantReportDto[]> {
    const apiKey: string | undefined = this.environment.assistantReportsApiKey;
    if (!apiKey) {
      return of([]);
    }

    return this.baseApiService.get(this.baseUrl, { params, headers: { Authorization: `Api-Key ${apiKey}` } }).pipe(
      catchError((error: HttpErrorResponse) => this.baseApiService.catchApiError(error)),
      map((response: ResponseDto<AssistantReportDto[]>) => this.baseApiService.mapResponse(response)),
    );
  }
}
